import { diagnosticLogger } from './diagnosticLogger';
import { getWebBundleMeta } from './webBundleMeta';

let logged = false;

async function reportBundleShaToConnector(meta: ReturnType<typeof getWebBundleMeta>): Promise<void> {
  if (typeof window === 'undefined') return;
  const invoke = (window as any).__TAURI__?.core?.invoke;
  if (typeof invoke !== 'function') return;
  try {
    await invoke('webview_report_bundle_sha', {
      url: String(window.location.href || ''),
      sha: meta.sha || meta.gitHash || '',
      bundle_hash: meta.bundleHash || '',
    });
  } catch {
    /* non-fatal — Rust page-load hook is the primary path */
  }
}

/** Once per page load — fleet JSONL + support snapshot header context. */
export function logWebBundleMetaOnce(): void {
  if (logged || typeof window === 'undefined') return;
  logged = true;

  const meta = getWebBundleMeta();
  try {
    (window as any).__MAESTRO_WEB_BUNDLE_SHA__ = meta.sha || meta.gitHash || '';
    if (meta.bundleHash) {
      (window as any).__MAESTRO_BUNDLE_HASH__ = meta.bundleHash;
    }
  } catch {
    /* ignore */
  }
  void reportBundleShaToConnector(meta);
  try {
    diagnosticLogger.log({
      level: 'info',
      category: 'other',
      message: 'web bundle snapshot',
      payload: {
        web_bundle_sha: meta.sha,
        web_bundle_hash: meta.bundleHash || null,
        web_bundle_git_hash: meta.gitHash,
        web_version: meta.version,
        web_built: meta.buildTime,
        host: window.location.hostname,
      },
    });
  } catch {
    /* never throw from boot logging */
  }
}
